import { TrendingUp, Zap } from "lucide-react";

export function ImprovementHints({ stream }) {
  const hints = stream.hints || [];
  if (stream.scoring_model === "eligibility") return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="improvement-hints">
      <div className="flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#FEF2F2] text-[#C8102E]"><TrendingUp className="h-5 w-5" /></span>
        <div>
          <h3 className="font-heading text-base font-semibold text-slate-900">What would lift your score</h3>
          <p className="text-xs text-slate-500">Estimated gains from this stream's point rules{stream.cutoff != null ? ` · cutoff ~${stream.cutoff}` : ""}</p>
        </div>
      </div>
      {hints.length === 0 ? (
        <p className="mt-4 text-sm text-slate-500">You're already at the top of every factor we model for this stream.</p>
      ) : (
        <ul className="mt-4 divide-y divide-slate-100">
          {hints.map((h, i) => (
            <li key={h.label} className="flex items-center justify-between gap-4 py-3" data-testid={`hint-${i}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800">{h.label}</p>
                {h.crosses_cutoff && (
                  <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700" data-testid={`hint-crosses-${i}`}>
                    <Zap className="h-3 w-3" /> Puts you over the cutoff
                  </span>
                )}
              </div>
              <div className="shrink-0 text-right">
                <span className="font-mono-tech text-lg font-bold text-emerald-600">+{h.gain}</span>
                <p className="text-xs text-slate-400">→ {h.new_score}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
